import React, { useContext } from 'react';
import proptypes from 'prop-types';
import classNames from 'classnames';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ImageHotspot } from '@thd-olt-component-react/image-hotspot';

const { string, bool, shape } = proptypes;

export const ImageWrapper = ({
  id,
  lazyLoad = false,
  imageRenderObj,
  sourceData = undefined
}) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const {
    link,
    altText,
    imageWidthClasses,
    leftSpaceClasses,
    imageFirst,
    mobilePreviewImage,
    previewImage
  } = imageRenderObj;

  const mobileHotspotId = mobilePreviewImage?.imageHotspot?.id;
  const desktopHotspotId = previewImage?.imageHotspot?.id;
  const isHotspotImage = desktopHotspotId || mobileHotspotId || sourceData?.hotspot;

  const getImageUrl = (imageData) => imageData?.damDownloadedContent?.url
    || imageData?.damContentSelector?.assetData?.[0]?.selectedImageUrl || '';

  const mobileImageUrl = getImageUrl(mobilePreviewImage);
  const desktopImageUrl = getImageUrl(previewImage);

  const imageWrapperClasses = classNames(`sui-grid 
    ${leftSpaceClasses} ${imageWidthClasses}`, {
    'sui-order-2': !imageFirst,
    'sui-order-1': imageFirst,
    'hover:sui-shadow-lg hover:sui-cursor-pointer': !!link
  });

  return (
    <div
      data-testid="image-width-test"
      className={imageWrapperClasses}
      href={link}
    >
      <a href={link}>
        {isHotspotImage ? (
          <ErrorBoundary name="image-hotspot">
            <QueryProvider cacheKey="image-hotspot">
              <ImageHotspot
                componentId={isMobile ? mobileHotspotId : desktopHotspotId}
                componentClass="ImageHotspot"
                parentId={id}
                ssrImageData={{
                  mobileImageSrc: mobileImageUrl,
                  responsiveImages: [{
                    imageSrc: desktopImageUrl,
                    mediaQuery: '(min-width: 1024px)'
                  }]
                }}
                sourceData={sourceData}
              />
            </QueryProvider>
          </ErrorBoundary>
        )
          : (
            <picture style={{ width: '100%' }}>
              <source
                media="(min-width: 1024px)"
                alt={altText}
                className="sui-w-full sui-h-auto sui-top-0 sui-left-0"
                srcSet={desktopImageUrl}
                data-testid="newspaper-image-desktop"
              />
              {/* eslint-disable-next-line @mizdra/layout-shift/require-size-attributes */}
              <img
                src={mobileImageUrl}
                alt={altText}
                className="sui-w-full sui-h-auto sui-top-0 sui-left-0"
                data-testid="newspaper-image-img"
                loading={lazyLoad ? 'lazy' : 'eager'}
              />
            </picture>
          )}
      </a>
    </div>
  );
};

ImageWrapper.propTypes = {
  imageRenderObj: shape({}).isRequired,
  id: string.isRequired,
  lazyLoad: bool,
  sourceData: shape({})
};